import axios from 'axios';
import Vue from 'vue';

const state = { status: '', team: {}, error: {}};

const getters = {
  getTopActivity: state => state.user.top_activity,
  getTeam: state => state.team,
  getError: state => state.error,
};

const actions = {
  loadTeam({commit, dispatch}, team_id) {
    return new Promise((resolve, reject) => {
    //const user_id = localStorage.getItem('user_id');
    axios({url: `${process.env.VUE_APP_ROOT_API}/teams/${team_id}/`})
      .then(resp => {
        const team = resp.data;
        commit('setTeam', team);
        resolve(resp);
      })
      .catch(error => {
       reject(error);
      })
    })
  },
  updateTeam({commit, dispatch}, user) {
    return new Promise((resolve, reject) => {

      axios({url: `${process.env.VUE_APP_ROOT_API}/teams/${user.team_id}/`, data: user.formData, method: 'PATCH', headers: {'Content-Type': 'multipart/form-data'}})
      .then(resp => {
        const team = resp.data;
        console.log(team)
        commit('setTeam', team);
        resolve(resp);
      })
      .catch(error => {
        const err = error.response.data;
        commit('setError', err);
        reject(error);
      })
    })
  },
};

const mutations = {
  setTeam (state, team) {
    state.status = 'success';
    state.team = team;
  },
  setError (state, error) {
    state.status = 'error';
    state.error = error;
  },

};
const namespaced = true;
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
